$(document).ready(function(e) {

	//menu expand toggles
	//loop though all menu toggles and display the relevent icon
	$('.menu_expand').each(function(){
		expandMenuToggles($(this),true);
	}); 

	$('.menu_expand').click(function(){
		expandMenuToggles($(this),false);
		var that = this;
		$(this).parent().next('ul').slideToggle("slow");
	});

});


function expandMenuToggles(item,rev){
	//get div id to be collapsed
	div_id = item.parent().next('ul');
	//check if the div is visible
	visible = $(div_id).is(":visible"); 

	if(visible){
		if(!rev){
			//remove minus class and add plus class
			item.removeClass('fa-minus-square-o');
			item.removeClass('green');
			item.parent().parent().removeClass('active');
			item.addClass('fa-plus-square-o');
		}else{
			item.addClass('fa-minus-square-o');
			item.addClass('green');
			item.parent().parent().addClass('active');
			item.removeClass('fa-plus-square-o');
		}
	}else{
		if(!rev){
			item.addClass('fa-minus-square-o');
			item.addClass('green');
			item.parent().parent().addClass('active');
			item.removeClass('fa-plus-square-o');
		}else{
			item.removeClass('fa-minus-square-o');
			item.removeClass('green');
			item.parent().parent().removeClass('active');
			item.addClass('fa-plus-square-o');
		}
	}
}